module.exports = __webpack_public_path__ + "img/profit.6839fa06.png";